import { render, staticRenderFns } from "./ProfitAnalysis.vue?vue&type=template&id=0a2fd373&scoped=true"
import script from "./ProfitAnalysis.vue?vue&type=script&lang=js"
export * from "./ProfitAnalysis.vue?vue&type=script&lang=js"
import style0 from "./ProfitAnalysis.vue?vue&type=style&index=0&id=0a2fd373&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0a2fd373",
  null
  
)

export default component.exports